module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_69-6b4db67ea06738a1eedee49302cd969d.png";